import { useTheme } from '@mui/material'
import { useMemo } from 'react'

import { useOnSubmit } from '../hooks/useOnSubmit'
import { EditTrafficProfileModalProps } from '../types'
import { computeBaseFactorForUI } from '../utils/trafficFactor'
import { DrivingTime } from './fields/DrivingTime'
import { TrafficDescription } from './fields/TrafficDescription'
import { form } from './formState'
import { FormFooter } from './FormFooter'

export function Body(props: EditTrafficProfileModalProps) {
  const { trafficProfile } = props

  const onSubmit = useOnSubmit(trafficProfile)
  const theme = useTheme()

  const config = useMemo(
    () => ({
      id: 'traffic-profile-time-windows-form',
      initialValues: {
        description: trafficProfile.description,
        baseTrafficFactor: computeBaseFactorForUI(trafficProfile.baseTrafficFactor),
      },
    }),
    [trafficProfile],
  )

  return (
    <form.Form
      config={config}
      width={420}
      fieldsPadding={`${theme.spacing(2)} 0 ${theme.spacing(3)} 0`}
      fieldsSpacing={4}
      onSubmit={(_, __, formApi) => {
        onSubmit(formApi.getValues())
      }}
      stopEditingOnUnmount={false}
      requireTransaction
      applyPendingFitMapOnMount={false}
      sx={{ minHeight: 310 }}
      disableScroll
      footer={<FormFooter />}
    >
      <DrivingTime />
      <TrafficDescription />
    </form.Form>
  )
}
